import React from 'react';
import { useAuthenticator } from '@aws-amplify/ui-react';
import SuperchatWidget from './SuperchatWidget';

/**
 * Supplies the one piece of context SuperchatWidget needs — which side of the
 * login boundary we are on — without the widget itself depending on the
 * Authenticator, so its placement rules stay testable in isolation.
 *
 * 'configuring' counts as signed out: during that window the login screen is what
 * the reader is looking at.
 */
const SuperchatWidgetMount = () => {
	const { authStatus } = useAuthenticator((context) => [context.authStatus]);
	return <SuperchatWidget signedIn={authStatus === 'authenticated'} />;
};

export default SuperchatWidgetMount;
